/*Listado de comodidades de cada habitación*/
/* eslint-disable comma-spacing */
const possibleServices = {
 gimnasio        : { key : "gimnasio"        , text : "免费健身房"                , spanish : "accesogratuitoalgimnasio"               } ,
 albornoz        : { key : "albornoz"        , text : "浴袍"                     , spanish : "albornoz"                               } ,
 salon           : { key : "salon"           , text : "客厅角"                   , spanish : "areadeestar"                            } ,
 cajafuerte      : { key : "cajafuerte"      , text : "保险箱"                   , spanish : "cajafuertedigital"                      } ,
 idiomas         : { key : "idiomas"         , text : "提供多种语言选项"           , spanish : "canalesenotrosidiomas"                  } ,
 internacionales : { key : "internacionales" , text : "国际电视频道"              , spanish : "canalesinternacionales"                 } ,
 ducha           : { key : "ducha"           , text : "浴缸和淋浴"               , spanish : "combinadodeduchaybañera"                } ,
 cunas           : { key : "cunas"           , text : "提供婴儿床"               , spanish : "disponibilidaddecunas"                  } ,
 duplex          : { key : "duplex"          , text : "复式房"                   , spanish : "habitacionduplex"                       } ,
 nofumador       : { key : "nofumador"       , text : "无烟房"                   , spanish : "habitacionesparanofumadoresdisponibles" } ,
 amenities       : { key : "amenities"       , text : "一次性洗漱用品"            , spanish : "kitdeamenities"                         } ,
 minibar         : { key : "minibar"         , text : "小冰箱"                   , spanish : "minibar"                                } ,
 nomascotas      : { key : "nomascotas"      , text : "不允许携带宠物入住"         , spanish : "noseaceptanmascotas"                    } ,
 pantuflas       : { key : "pantuflas"       , text : "便鞋"                     , spanish : "pantuflas"                              } ,
 plancha         : { key : "plancha"         , text : "熨斗和熨衣板 (根据需求)"    , spanish : "planchaytabladeplanchadobajopeticion"   } ,
 secador         : { key : "secador"         , text : "吹风机"                   , spanish : "secadordepeloprofesional"               } ,
 almohadas       : { key : "almohadas"       , text : "酒店房间同样提供睡枕选择"    , spanish : "selecciondealmohadasenlahabitacion"     } ,
 sofacama        : { key : "sofacama"        , text : "沙发床"                   , spanish : "sofacama"                               } ,
 wifipremium     : { key : "wifipremium"     , text : "高速Wifi"                 , spanish : "wifidealtavelocidaddisponible"          } ,
 wifi            : { key : "wifi"            , text : "免费Wifi"                 , spanish : "wifigratis"                             } ,
}

function getServices(keys) {
  return keys.map(k => possibleServices[k].text)
}

const habitaciones = [
  { 
    key: "deluxe",
    title: "豪华双人间", 
    subtitle: "Habitacion Deluxe",
    size: "25m²",
    details: "1超大号双人床2单人床",
    people: 2,
    imagen: "Deluxe",
    imagenurl:"/static/img/nh/fichaNH_habdeluxe.jpg",
    characteristics: [ "aireAcondicionado", "cama", "tv", "ducha", "cafetera", "tetera", "albornoz", ],
    services: getServices([ "cunas", "albornoz", "idiomas", "almohadas", "gimnasio", "cajafuerte", "wifi", "wifipremium", "plancha", "minibar", "nomascotas", "secador", "ducha", "pantuflas" ])
  },
  { 
    key: "premium",
    title: "精选双人间", 
    subtitle: "Habitacion Premium",
    size: "25m²",
    details: "1超大号双人床2单人床",
    people: 3,
    imagen: "Premium",
    imagenurl:"/static/img/nh/fichaNH_habpremium.jpg",
    // #TODO: falta uno, "Reformado", el sofá con un cuadro que hay frente al perro abajo...
    characteristics: [ "aireAcondicionado", "cama", "ducha", "cafetera", "tetera", "albornoz", ],
    services: getServices([ "cunas", "amenities", "almohadas", "gimnasio", "cajafuerte", "wifi", "wifipremium", "internacionales", "plancha", "minibar", "nomascotas", "secador", "ducha", "pantuflas" ])
  },
  { 
    key: "familiar",
    title: "家庭", 
    subtitle: "Habitacion Familiar con vista",
    size: "45m²",
    details: "1超大号双人床1双人床",
    people: 3,
    imagen: "Familiar-con-vista",
    imagenurl:"/static/img/nh/fichaNH_habfamiliar.jpg",
    // #TODO: falta uno, "Reformado", el sofá con un cuadro que hay frente al perro abajo...
    // #TODO: falta "Vistas"
    characteristics: [ "aireAcondicionado", "cama", "ducha", "cafetera", "tetera", "albornoz", ],
    services: getServices([ "cunas", "amenities","almohadas", "gimnasio", "cajafuerte", "wifi", "wifipremium", "internacionales", "plancha", "minibar", "nomascotas", "secador", "ducha", "pantuflas", "sofacama" ])
  },
  { 
    key: "junior",
    title: "普通套间", 
    subtitle: "Junior Suite",
    size: "45m²",
    details: "1超大号双人床2单人床",
    people: 2,
    imagen: "Junior-Suite",
    imagenurl:"/static/img/nh/fichaNH_habjuniorsuite.jpg",
    characteristics: [ "aireAcondicionado", "cama", "tv", "ducha", "cafetera", "tetera", "albornoz", ],
    services: getServices([ "cunas", "almohadas", "gimnasio", "cajafuerte", "wifi", "wifipremium", "internacionales", "plancha", "minibar", "amenities", "nomascotas", "secador", "ducha", "salon", "pantuflas", "sofacama" ])
  },
  { 
    key: "suite",
    title: "套房", 
    subtitle: "Suite",
    size: "78m²",
    details: "1超大号双人床",
    people: 2,
    imagen: "Suite",
    imagenurl:"/static/img/nh/fichaNH_habsuite.jpg",
    characteristics: [ "aireAcondicionado", "cama", "tv", "ducha", "cafetera", "tetera", "albornoz", ],
    services: getServices([ "duplex", "cunas", "amenities", "idiomas", "almohadas", "gimnasio", "cajafuerte", "wifi", "wifipremium", "plancha", "minibar", "nofumador", "nomascotas", "secador", "ducha", "salon", "pantuflas", "sofacama" ])

  },
]

export default habitaciones



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/rooms.js